import { Button, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';
import { ProjectsListLayout } from 'shared/components/admin/ProjectsListLayout';
import { TwoColumnsLayout } from 'shared/components/admin/TwoColumnsLayout';

import { useAppDispatch } from 'shared/hooks';
import { ProjectsListContainer } from '../ProjectsListContainer';
import { PaginationContainer } from '../PaginationContainer';
import { LimitContainer } from '../LimitContainer';
import { ProjectModalContainer } from '../ProjectModalContainer';
import { openProjectModal } from 'shared/slices/admin/projectModal';
import { AlertContainer } from '../AlertContainer';

export const ProjectsListPageContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  /* istanbul ignore next */
  const onClick = React.useCallback(() => {
    dispatch(openProjectModal());
  }, [dispatch]);

  return (
    <ProjectsListLayout>
      <TwoColumnsLayout>
        <UIHeading1>Проекты</UIHeading1>
        <Button size="L" onClick={onClick}>
          Создать проект
        </Button>
      </TwoColumnsLayout>
      <ProjectsListContainer />
      <TwoColumnsLayout>
        <LimitContainer />
        <PaginationContainer />
      </TwoColumnsLayout>
      <ProjectModalContainer />
      <AlertContainer />
    </ProjectsListLayout>
  );
};
